import { renderToString } from 'react-dom/server'

const columns = [
  {
    data: 'name',
    className: 'bold',
    render: function (data, type, row, meta) {
      return renderToString(<a href={`/admin/settings/email_templates/${row['id']}/edit`}>{data}</a>)
    },
  },
  {
    data: 'description',
    render: (data) => renderToString(<span>{data}</span>)
  },
  {
    data: 'id',
    className: 'right',
    render: (data) => renderToString(
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <button
          className="button small smaller primary clone-template-button"
          type="button"
          data-template-id={data}
        >
          Duplicate
        </button>
        <button
          className="button small smaller red delete-template-button"
          type="button"
          data-template-id={data}
        >
          Delete
        </button>
      </div>
    ),
  },
]

const headers = ['Name', 'Description', '']

const filters = []

const order = [[0, "asc"]]

const sorters = [
  { column: 0, label: 'Alphabetically (A-Z)', order: 'asc' },
  { column: 0, label: 'Alphabetically (Z-A)', order: 'desc' },
]

export { columns, headers, filters, sorters, order }
